export default "__VITE_ASSET__hdlam3ig__"